__turbopack_context__.v({
  "connector": "scoring-method-stage-module__PGO17G__connector",
  "database": "scoring-method-stage-module__PGO17G__database",
  "databaseScale": "scoring-method-stage-module__PGO17G__databaseScale",
  "frame": "scoring-method-stage-module__PGO17G__frame",
  "merge": "scoring-method-stage-module__PGO17G__merge",
  "metricDot": "scoring-method-stage-module__PGO17G__metricDot",
  "metricGroup": "scoring-method-stage-module__PGO17G__metricGroup",
  "normalizationStage": "scoring-method-stage-module__PGO17G__normalizationStage",
  "percentileLabel": "scoring-method-stage-module__PGO17G__percentileLabel",
  "percentileTrack": "scoring-method-stage-module__PGO17G__percentileTrack",
  "pipeline": "scoring-method-stage-module__PGO17G__pipeline",
  "rating": "scoring-method-stage-module__PGO17G__rating",
  "research": "scoring-method-stage-module__PGO17G__research",
  "scaleEnds": "scoring-method-stage-module__PGO17G__scaleEnds",
  "scoreEquation": "scoring-method-stage-module__PGO17G__scoreEquation",
  "scoreResult": "scoring-method-stage-module__PGO17G__scoreResult",
  "scoreToken": "scoring-method-stage-module__PGO17G__scoreToken",
  "stage": "scoring-method-stage-module__PGO17G__stage",
  "stageHeader": "scoring-method-stage-module__PGO17G__stageHeader",
  "stockExample": "scoring-method-stage-module__PGO17G__stockExample",
  "summary": "scoring-method-stage-module__PGO17G__summary",
  "visual": "scoring-method-stage-module__PGO17G__visual",
  "weightBar": "scoring-method-stage-module__PGO17G__weightBar",
  "weightBarShort": "scoring-method-stage-module__PGO17G__weightBarShort",
  "weightRow": "scoring-method-stage-module__PGO17G__weightRow",
  "weighting": "scoring-method-stage-module__PGO17G__weighting",
});
